module.exports = __webpack_public_path__ + "static/hl-infographic-mobile-fd9b49f485c1bae6dd6fe7549c2e8cb6.png";